export enum SearchFilterFieldType {
	Normal = 1,
	Typeahead = 2
}